import React from "react";
import DataSet from "@antv/data-set";
import {
    Chart,
    Geom,
    Axis,
    Tooltip,
    Legend,
} from "bizcharts";

function BarsVertical({ data, fields, max, min = 0, tickInterval, axis, height }){
    const ds = new DataSet();
    const dv = ds.createView().source(data);
        dv.transform({
          type: "fold",
          fields: fields,
          key: "type",
          value: "value" 
    }); 

    let scale = {};
    
    if(tickInterval !== undefined){
        scale = {
            value:{
                max:max,
                min:min,
                tickInterval: 0.25
            },
        }
    }else{
        scale = {
            value:{
                max:max,
                min:min,
            },
        }
    }

    if(data.length > 0 && fields.length > 0){
        return(
            <div>
                <Chart 
                    height={height ? height : 400} 
                    data={dv} 
                    scale={scale} 
                    forceFit 
                    padding={[40, 60, 40, 50]}
                > 
                    <Axis name="type" />
                    <Axis 
                        name="value" 
                        label={{
                            formatter: val => {
                                if(axis) return val + axis
                                else return `${val}`
                            }
                        }}
                    />
                    <Legend />
                    <Tooltip
                        crosshairs={{
                            type: "y"
                        }}
                    />
                    <Geom
                        type="interval"
                        position="type*value"
                        color={"name"}
                        adjust={[
                            {
                                type: "dodge",
                                marginRatio: 1 / 32
                            }
                        ]}
                        tooltip={[
                            'name*value',
                            (name, value) => {
                                if(axis){
                                    return {
                                        name: name,
                                        value: value + axis,
                                    };
                                }else{
                                    return {
                                        name: name,
                                        value: `${value}`,
                                    };
                                }
                            },
                        ]}
                    />
                </Chart>
            </div>
        )
    }else return null
}

export default BarsVertical;


// WEBPACK FOOTER //
// ./src/components/common/charts/BarsVertical.jsx